import React, { useRef, useEffect, useState, Fragment, useLayoutEffect } from 'react';
import cn from 'classnames';
import { useSelector } from 'react-redux';
import QuickSearch from './QuickSearch';
import { debounce } from "lodash";
import NavigationItem from './NavigationItem';
import uuid4 from "uuid4";

const MegaMenu = ({ links = [], contentLink = null, helpDeskUrl = "", addressInformation = "", ChannelsNamesAndUrls = [], configuratorLink = "", logo = "", startpageurl = "", configuratorOpenMode = "" }) => {
    const {
        showFullForm,
    } = useSelector((state) => state.quickSearch);
    const menuRef = useRef(null);
    const [firstLevelSelectedIndex, setFirstLevelSelectedIndex] = useState(-1);
    const [secondLevelSelectedIndex, setSecondLevelSelectedIndex] = useState(-1);
    const [secondLevelObject, setSecondLevelItems] = useState([]);
    const hasNameOrChildren = (link) => link.name || (link.links || []).length > 0;
    const [count, setCount] = React.useState(0);
    const contentLinks = useSelector((state) => state.navigation.contentLinks);

    const handleClickOutside = () => {
        setCount(0);
    };

    const handleConfiguratorClick = (e) => {
        e.preventDefault();
        const url = configuratorLink.Url;

        if (configuratorOpenMode === "NewTab") {
            window.open(url, '_blank');
        } else if (configuratorOpenMode === "NewWindow") {
            window.open(url, '_blank', 'noopener,noreferrer,width=800,height=600');
        } else if (configuratorOpenMode === "SameWindow") {
            window.location.href = url;
        }
    };

    var channelsListItems = ChannelsNamesAndUrls.map((channel, i) =>
    {
        if (!channel.isSelected)
            return <li key={uuid4()}><a key={uuid4()} href={channel.url}>{channel.name}</a></li>
    });

    const currentChannelItem = ChannelsNamesAndUrls.map((channel, i) => {
        if (channel.isSelected)
            return <span key={uuid4()} id="languageButton">{channel.name}</span>
    });

    const handleMouseLeave = debounce(() => {
        setFirstLevelSelectedIndex(-1);
        setSecondLevelSelectedIndex(-1);
    }, 800);

    const useOutsideClick = (callback) => {
        const ref = React.useRef();

        React.useEffect(() => {
            const handleClick = (event) => {
                if (ref.current && !ref.current.contains(event.target) && ref.current.classList.contains('show__list__desktop') && event.target.id !== 'languageButton') {
                    document.getElementById("country__selector__dropdown__desktop").classList.toggle("show__list__desktop");
                    callback();
                }
            };

            document.addEventListener('click', handleClick, true);

            return () => {
                document.removeEventListener('click', handleClick, true);
            };
        }, [ref]);

        return ref;
    };

    const ref = useOutsideClick(handleClickOutside);

    return (
        <Fragment>
            <div className="header__row compact-header header__row--one-row">
                <a href={startpageurl} className="header__logo">
                    <img src={logo}></img>
                </a>
                {links.length > 0 && (
                    <div className="megamenu__toggle">
                        <ul>
                            {links.map(
                                (link, i) =>
                                    <li key={uuid4()} className={cn({ 'megamenu__toggle__active': i === firstLevelSelectedIndex })}
>
                                        <button key={uuid4()} type="button"
                                            onMouseOver={() => {
                                            if (link.links.length != 0) {
                                                setFirstLevelSelectedIndex(i);
                                                setSecondLevelSelectedIndex(i);
                                                setSecondLevelItems(link.links);
                                                }
                                            }}
                                            onClick={(e) => {
                                                e.preventDefault();
                                                window.location.href = link.url;
                                            }}>

                                            {link.name}
   
                                        </button>
                                    </li> 
                            )}
                        </ul>
                    </div>
                )}
                <div className="header__components">
                    <QuickSearch></QuickSearch>
                    {configuratorLink.Url ? 
                    <div className="c-configurator-link">
                        <a href={configuratorLink.Url} onClick={handleConfiguratorClick}>
                                <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 400 400">
                                    <path className="cls-2" d="M200.8,314.88h-37.66v-16.56c0-13.55-7.93-24.62-18.45-32.08-25.59-18.16-42.75-47.62-42.75-81.38,0-54.59,44.26-98.85,98.85-98.85s98.85,44.26,98.85,98.85c0,33.75-17.15,63.22-42.75,81.38-10.51,7.46-18.45,18.53-18.45,32.08v16.56h-37.66Z" />
                                    <path className="cls-1" d="M237.41,152.64v34.68c.01,1.99-2.62,2.7-3.62.98l-20.71-35.66h-24.4s.01,34.68.01,34.68c0,1.99-2.63,2.7-3.63.98l-20.71-35.66h-24.35v41.93l24.35,41.93h24.35v-34.82c.12-1.88,2.64-2.53,3.62-.85l20.71,35.66h24.35l24.38-41.93v-41.93h-24.35Z" />
                                    <path className="cls-2" d="M163.14,314.88h75.28v37.23c0,1.1-.9,2-2,2h-71.26c-1.11,0-2.01-.9-2.01-2.01v-37.22h0Z" />
                                    <path className="cls-2" d="M185.56,354.12v5.85c0,8.54,6.92,15.46,15.46,15.46s15.46-6.92,15.46-15.46v-5.85" />
                                    <line className="cls-2" x1="201.05" y1="11.43" x2="201.05" y2="54.43" />
                                    <line className="cls-2" x1="357.51" y1="104.1" x2="320.27" y2="125.6" />
                                    <line className="cls-2" x1="320.27" y1="248.4" x2="357.51" y2="269.9" />
                                    <line className="cls-2" x1="42.49" y1="269.9" x2="79.73" y2="248.4" />
                                    <line className="cls-2" x1="85.59" y1="118.01" x2="48.35" y2="96.51" />
                                </svg>
                            <div className="sr-only">Go to configurator</div>
                        </a>
                    </div> : null}
                    
                    <div className="c-langselect">
                        <button className="button" type="button" data-toggle="example-dropdown" onClick={() => {
                                document.getElementById("country__selector__dropdown__desktop").classList.toggle("show__list__desktop");
                        }}>
                            <svg id="languageButton" xmlns="http://www.w3.org/2000/svg" width="23.578" height="23.577" viewBox="0 0 23.578 23.577">
                                <path id="globe" d="M11.566-.22A11.641,11.641,0,0,0,6.612.872V.854L6.486.923l-.045.03h0A11.788,11.788,0,1,0,11.566-.22Zm.672,22.807c-.231,0-.456.024-.672.024a10.9,10.9,0,0,1-3.706-.648,4.8,4.8,0,0,1,4.378.621Zm1.1-.12a6.077,6.077,0,0,0-3.9-1.536,5.468,5.468,0,0,0-2.536.636,11.056,11.056,0,0,1-2.83-1.915,3.9,3.9,0,0,0,.072-.921,3.274,3.274,0,0,1,0-.375,10.683,10.683,0,0,1,.36-1.774A2.811,2.811,0,0,0,4.346,14.3a3.625,3.625,0,0,0-.741-.822,4.558,4.558,0,0,1-.441-.432,2.062,2.062,0,0,1-.474-1.2,4.385,4.385,0,0,1,0-.444,3.382,3.382,0,0,0-.048-.861,1.9,1.9,0,0,0-.927-1.2,1.975,1.975,0,0,0-.9-.261,10.533,10.533,0,0,1,.363-1.239,2.179,2.179,0,0,0,1.389-.711,3.354,3.354,0,0,1,1.612-.885A2.17,2.17,0,0,0,5.528,5.2a2.977,2.977,0,0,0,.2-1.287V3.447a2.374,2.374,0,0,1,1.038-1.8,10.9,10.9,0,0,1,4.8-1.092A11.161,11.161,0,0,1,13.5.725v.3a1.113,1.113,0,0,1-.222.861,1.338,1.338,0,0,1-.858.36,2.9,2.9,0,0,0-.873.264,1.1,1.1,0,0,0-.51.936,1.017,1.017,0,0,1-.066.3,1.6,1.6,0,0,1-.69.474,4.15,4.15,0,0,0-.423.222,1.636,1.636,0,0,0-.9,1.585,1.4,1.4,0,0,0,.717.9,4.22,4.22,0,0,0,2.491.321h.147c.5-.057,1.8-.2,2.224.18a.4.4,0,0,1,.114.342c-.03.507-.84.57-1.317.558a13.2,13.2,0,0,1-1.341-.114c-1.53-.18-3.265-.384-4.375.669a3.571,3.571,0,0,0-1.074,2.629,2.722,2.722,0,0,0,.846,2.014,3.2,3.2,0,0,0,1.8.639,2.821,2.821,0,0,1,1.236.351c.42.3.5.939.576,1.636a4.306,4.306,0,0,0,.339,1.467,4.18,4.18,0,0,0,.357.546,2.581,2.581,0,0,1,.354.6c.033.09.066.183.1.282.237.684.558,1.624,1.693,1.624a2.184,2.184,0,0,0,1.8-1.362,5.735,5.735,0,0,0,.375-2.1,5.669,5.669,0,0,1,.249-1.672,4.3,4.3,0,0,1,.486-.753c.513-.7,1.092-1.5.711-2.137a1.846,1.846,0,0,0-.39-.435.936.936,0,0,1-.261-.3.228.228,0,0,1,.045-.225,1.02,1.02,0,0,1,.582-.216,1.693,1.693,0,0,0,1.245-.7c.264-.3.366-.384.531-.345s.237.186.345.6l.063.225a1.137,1.137,0,0,0,.522.666.7.7,0,0,0,.558.054,1.275,1.275,0,0,0,.765-.936c.123-.375.183-.48.375-.519a.435.435,0,0,1,.342.1l.033.027a.9.9,0,0,1,.351.465q0,.225,0,.45a11.052,11.052,0,0,1-9.225,10.908ZM1.9,10.715a2.725,2.725,0,0,1,.042.675,4.928,4.928,0,0,0,0,.516A2.815,2.815,0,0,0,2.6,13.524a5.122,5.122,0,0,0,.528.525,3,3,0,0,1,.6.645A2.005,2.005,0,0,1,3.8,16.375a11.836,11.836,0,0,0-.384,1.894,3.748,3.748,0,0,0-.015.39v.3A10.977,10.977,0,0,1,.529,11.571,11.3,11.3,0,0,1,.667,9.842,1.161,1.161,0,0,1,1.345,10a1.14,1.14,0,0,1,.558.717ZM4.985,3.384c-.015.18-.015.36-.015.534a2.314,2.314,0,0,1-.123.954,1.422,1.422,0,0,1-.9.654,4.049,4.049,0,0,0-1.939,1.1,1.32,1.32,0,0,1-.465.342A11.065,11.065,0,0,1,5.144,2.6a3.166,3.166,0,0,0-.159.783ZM14.249,1.01V.869a11.1,11.1,0,0,1,8.223,9.036,1.161,1.161,0,0,0-.747-.114,1.291,1.291,0,0,0-.954,1.02c-.111.333-.15.411-.255.45a.42.42,0,0,1-.147-.213c-.018-.06-.033-.12-.054-.2a1.356,1.356,0,0,0-.9-1.149,1.275,1.275,0,0,0-1.278.585,1.666,1.666,0,0,1-.3.3,1.467,1.467,0,0,1-.507.15,1.627,1.627,0,0,0-1.005.45,1,1,0,0,0-.192,1,1.527,1.527,0,0,0,.468.6,1.26,1.26,0,0,1,.243.255c.126.21-.393.921-.672,1.3a4.369,4.369,0,0,0-.6.939,6.269,6.269,0,0,0-.3,1.9,5.132,5.132,0,0,1-.3,1.819,1.413,1.413,0,0,1-1.116.9c-.468,0-.684-.279-.972-1.116-.036-.1-.069-.2-.105-.3a3.376,3.376,0,0,0-.456-.771,3.6,3.6,0,0,1-.3-.441,3.67,3.67,0,0,1-.261-1.2,2.763,2.763,0,0,0-.9-2.167,3.412,3.412,0,0,0-1.566-.474,2.562,2.562,0,0,1-1.4-.462,1.972,1.972,0,0,1-.6-1.458,2.791,2.791,0,0,1,.864-2.062,2.783,2.783,0,0,1,2.017-.6,15.191,15.191,0,0,1,1.753.138,13.381,13.381,0,0,0,1.419.12H13.4c1.693,0,1.993-.8,2.02-1.269a1.128,1.128,0,0,0-.348-.936c-.663-.63-2.077-.468-2.833-.381H12.1a3.552,3.552,0,0,1-2.044-.231.639.639,0,0,1-.339-.4c-.057-.285.228-.6.54-.8.1-.063.231-.123.354-.183a2.125,2.125,0,0,0,1.014-.774,1.5,1.5,0,0,0,.168-.6c.033-.273.057-.327.117-.36a2.362,2.362,0,0,1,.657-.192,2.008,2.008,0,0,0,1.281-.6,1.738,1.738,0,0,0,.4-1.3Z" transform="translate(0.222 0.22)" />
                            </svg>
                            {currentChannelItem}
                        </button>
                        <div className="dropdown-pane" id="country__selector__dropdown__desktop" data-dropdown data-auto-focus="true" ref={ref}>
                            <ul>
                                {channelsListItems}
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="header__break"></div>
                <nav id="navbar" role="navigation" className="navbar">
                    <NavigationItem links={contentLinks} helpDeskUrl={helpDeskUrl} addressInformation={addressInformation} ChannelsNamesAndUrls={ChannelsNamesAndUrls} configuratorLink={configuratorLink} logo={logo} renderMobileItems></NavigationItem>
                </nav>
            </div>
            {secondLevelObject && secondLevelSelectedIndex >= 0 && (
                <div className="c-megamenu c-megamenu--open"
                    onMouseLeave={() => {
                    handleMouseLeave();

                }}>
                    <div className="row">
                        <div className="columns">
                            <div className="c-megamenu__content">
                                {secondLevelObject.map(
                                    (link, i) => hasNameOrChildren(link) && (
                                        <div key={uuid4()} className="c-megamenu__content__col">
                                            {link.url && link.name && (
                                                <h2 key={uuid4()}><a key={uuid4()} href={link.url}><span>{link.name}</span></a></h2>)
                                            }
                                            {link.links && link.links.length > 0 && (
                                                <ul>
                                                    {link.links.map(
                                                        (link, i) =>
                                                            <li key={uuid4()}>
                                                                <a key={uuid4()} href={link.url}><span>{link.name}</span></a>
                                                            </li>
                                                    )}
                                                </ul>
                                            )}
                                        </div>
                                    )
                                )}
                            </div>
                        </div>
                    </div>
             </div>
            )}
        </Fragment>
    );
};

export default MegaMenu;
